import PayrollSummaryTable from './PayrollSummaryTable';

export default PayrollSummaryTable;
